module.exports = __webpack_public_path__ + "img/auditIng.c5bcf510.png";